import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useGenerateOgpImage } from "@roman/shared/hooks/PredictionMarket/useGenerateOgpImage";
import type { PredictionMarketWithProbability } from "@roman/shared/types/PredictionMarket";
import { Share2Icon } from "lucide-react";
import { useState } from "react";
import { EntrySharePopup } from "../EntrySharePopup";

interface EntryShareButtonProps {
  market: PredictionMarketWithProbability;
  className?: string;
}

export const EntryShareButton: React.FC<EntryShareButtonProps> = ({ market, className }) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const { generateOgpImage } = useGenerateOgpImage();

  const handleShareClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsShareModalOpen(true);
    await generateOgpImage({ marketId: market.id });
  };

  return (
    <>
      <Share2Icon className={`text-dark-gray w-5 h-5 cursor-pointer ${className || ""}`} onClick={handleShareClick} />

      <Dialog open={isShareModalOpen} onOpenChange={setIsShareModalOpen}>
        <DialogContent className="p-0 [&>button]:hidden gap-0 border-0 overflow-hidden rounded-lg w-[360px]">
          <EntrySharePopup market={market} onClose={() => setIsShareModalOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};
